<template>
  <div class="product-pile">
    <div class="product1">
      <img :src="require(is1920 ? '../assets/product1p.png' : '../assets/product28801p.png')"/>
    </div>
    <div class="product2">
      <img :src="require(is1920 ? '../assets/product2p.png' : '../assets/product28802p.png')"/>
      <div class="desc">
        <p>国恒充电智慧交流充电桩</p>
        <p>HD-AC7MP200</p>
        <p>精工打造 至高品质</p>
      </div>
    </div>
    <div class="product3">
      <img :src="require(is1920 ? '../assets/product3p.png' : '../assets/product28803p.png')"/>
      <div class="desc">
        <div class="one">
          <p>4核1.2G高速处理器</p>
          <p>主芯片</p>
        </div>
        <div class="two">
          <p>-20℃~50℃</p>
          <p>工作温度</p>
        </div>
        <div class="three">
          <p>32A 七孔</p>
          <p>输出端</p>
        </div>
      </div>
    </div>
    <div class="product4">
      <img :src="require(is1920 ? '../assets/product4p.png' : '../assets/product28804p.png')"/>
      <div class="desc">
        <div>
          <p>全国运维 快速响应</p>
          <p>专人定期巡检，无需担心充电盒被盗或被破坏，更安全</p>
        </div>
      </div>
    </div>
    <div class="product5">
      <div class="table">
        <div class="tr">
          <div>外观尺寸</div>
          <div>455mm*260mm*119mm</div>
        </div>
        <div class="tr">
          <div>输入电压</div>
          <div>176V～264V AC</div>
        </div>
        <div class="tr">
          <div>工作频率</div>
          <div>50Hz±5Hz</div>
        </div>
        <div class="tr">
          <div>额定电流</div>
          <div>32A</div>
        </div>
        <div class="tr">
          <div>额定功率</div>
          <div>7kW</div>
        </div>
        <div class="tr">
          <div>充电方式</div>
          <div>二维码</div>
        </div>
        <div class="tr">
          <div>充电接口</div>
          <div>充电枪（GB/T 20234.2-2015）</div>
        </div>
        <div class="tr">
          <div>枪线长度</div>
          <div>3米</div>
        </div>
        <div class="tr">
          <div>显示屏</div>
          <div>无</div>
        </div>
        <div class="tr">
          <div>安装方式</div>
          <div>壁挂/立柱</div>
        </div>
        <div class="tr">
          <div>工作环境</div>
          <div>－20℃～＋50℃  相对湿度5%～95%</div>
        </div>
        <div class="tr">
          <div>储存环境</div>
          <div>－40℃～＋85℃  相对湿度10%～95%</div>
        </div>
        <div class="tr">
          <div>海拔高度</div>
          <div>≤2000米</div>
        </div>
        <div class="tr">
          <div>适用场景</div>
          <div>户内户外</div>
        </div>
        <div class="tr">
          <div>安全保护</div>
          <div>漏电、过流、欠压、过压、板载防浪涌、防雷器（选配）</div>
        </div>
        <div class="tr">
          <div>IP等级</div>
          <div>IP54</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'productPile',
  inject: ['is1920']
}
</script>
<style lang="less">
.product-pile{
  width: 100%;
  background-color: white;
  >div{
    position: relative;
    height: 6rem;
    margin: 0;
  }
  p{
    margin: 0;
    text-align: left;
  }
  .product2{
    height: 8.18rem;
    .desc{
      position: absolute;
      top: 1.78rem;
      left: 3.56rem;
      p{
        &:nth-child(1){
          font-size: .48rem;
          line-height: .67rem;
          margin-bottom: .1rem;
        }
        &:nth-child(2){
          font-size: .38rem;
          line-height: .53rem;
          margin-bottom: .4rem;
        }
        &:nth-child(3){
          font-size: .32rem;
          line-height: .45rem;
          color: #13E4E8;
        }
      }
    }
  }
  .product3{
    height: 10.5rem;
    .desc{
      position: absolute;
      top: 1.15rem;
      width: 19.2rem;
      padding-left: 3.46rem;
      display: flex;
      >div{
        &.one{
          padding: 0 .54rem 0 0;
        }
        &.two{
          padding: 0 .72rem;
          border-left: 1px solid rgba(255, 255, 255, .5);
          border-right: 1px solid rgba(255, 255, 255, .5);
        }
        &.three{
          padding: 0 0 0 .85rem;
        }
        >p{
          &:first-child{
            color: white;
            font-size: .50rem;
            line-height: .70rem;
          }
          &:last-child{
            text-align: center;
            color: rgba(255, 255, 255, .6);
            font-size: .24rem;
            line-height: .33rem;
          }
        }
      }
    }
  }
  .product4{
    height: 11.62rem;
    .desc{
      width: 100%;
      position: absolute;
      top: 1.02rem;
      >div{
        p{
          text-align: center;
          &:nth-child(1){
            color: black;
            font-size: .60rem;
            line-height: .84rem;
          }
          &:nth-child(2){
            font-size: .26rem;
            color: #6D7278;
            line-height: .37rem;
          }
        }
      }
    }
  }
  .product5{
    height: 11.2rem;
    min-height: 11rem;
    width: 12rem;
    margin: .45rem auto 0;
    .table{
      border: 1px solid #979797;
      .tr{
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 1px solid #979797;
        }
        >div{
          color: #333;
          font-size: .28rem;
          line-height: .40rem;
          &:nth-child(1){
            width: 2.36rem;
            text-align: center;
            padding: .13rem 0;
          }
          &:nth-child(2){
            border-left: 1px solid #979797;
            width: 9.64rem;
            text-align: left;
            padding: .13rem .6rem;
            word-break:break-all;
          }
        }
      }
    }
  }
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
